import isEmptyObject from './is-empty-object';

function isEmptyArrayOrObject(value?: {} | unknown[]): boolean {
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return isEmptyObject(value);
}

export default isEmptyArrayOrObject;
